import { render } from "./VirtualKeyboard.vue?vue&type=template&id=c30929ec"
import script from "./VirtualKeyboard.vue?vue&type=script&lang=js"
export * from "./VirtualKeyboard.vue?vue&type=script&lang=js"

import "./VirtualKeyboard.vue?vue&type=style&index=0&id=c30929ec&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__